module.exports = __webpack_public_path__ + "static/media/Ekaterina_Chuvatkina.d79e90f8.jpg";